<template>
  <div id="DeptUser">
    <div class="search">
      <div class="searchItem">
        <el-input class="eb-input" v-model="searchKey" placeholder="请输入搜索内容" v-on:input="change"></el-input>
      </div>
    </div>
    <div class="deptUserButton">
      <el-button class="eb-button-red" @click="addUser">新增用户</el-button>
      <el-button class="eb-button-red" @click="deleteUser">删除用户</el-button>
      <el-button class="eb-button-red" @click="editUser">修改信息</el-button>
      <el-button class="eb-button-red" @click="setUserStatus">设置状态</el-button>
      <el-button class="eb-button-red" @click="resetUserPassword">重置密码</el-button>
      <el-button class="eb-button-red" @click="setNewManageUser">设置管理员</el-button>
    </div>
    <div class="deptUserTable eb-table">
      <el-table style="width:100%;" :data.sync="newPageData" :stripe="true" @current-change="handleCurrentRowChange">
        <el-table-column width="30">
          <template slot-scope="scope">
            <el-radio class="eb-radio" :label="scope.$index" v-model="radioValue"></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop='trueName' label="姓名" sortable></el-table-column>
        <el-table-column prop='departName' label="部门" sortable></el-table-column>
        <el-table-column prop='userPhone' label="手机" sortable></el-table-column>
        <el-table-column prop='userEmail' label="邮件" sortable></el-table-column>
        <el-table-column prop='userRoleNames' label="角色" sortable></el-table-column>
        <el-table-column prop='status' label="状态" sortable>
          <template slot-scope="scope">
            {{userStatus(scope.row.status)}}
          </template>
        </el-table-column>
      </el-table>
      <eb-pagination v-if="pageParams.totalCount" @current-change="handleCurrentChange" :current-page.sync="pageParams.currPage" :total="pageParams.totalCount" :page-size="pageParams.pageSize" />
    </div>
  </div>
</template>
<script>
import ebPagination from '@/components/common/eb-pagination/eb-pagination';
import eventBus from '@/plugins/event-bus';
import { clone } from 'lodash';
import { userSearch, USER_ROLE_GROUP, deleteU, initPwd, setNewManageUser } from '@/services/user/user-service';
export default {
  name: 'DeptUser',
  components: {
    ebPagination
  },
  data() {
    return {
      currentDept: '',
      pageData: [],
      tableData: [],
      pageParams: {
        currPage: 1,
        pageSize: 10,
        totalCount: null,
        totalPage: null
      },
      searchKey: '',
      currentSelectedRow: null,
      radioValue: null,
      managerUserId: parseInt(this.$store.state.user.userInfo.userid)
    };
  },
  created() {
    eventBus.$on('selectDeptNode', selectedDept => {
      this.currentDept = selectedDept;
      this.initList(selectedDept.departId);
    });
    eventBus.$on('addUserSuccess', departId => {
      this.initList(departId);
    });
  },
  computed: {
    newPageData: function() {
      return this.pageData.slice(
        (this.pageParams.currPage - 1) * this.pageParams.pageSize,
        this.pageParams.currPage * this.pageParams.pageSize
      );
    },
    totalPageCount: function() {
      return (
        parseInt(this.pageParams.totalCount / this.pageParams.pageSize) +
        (this.pageParams.totalCount % this.pageParams.pageSize === 0 ? 0 : 1)
      );
    }
  },
  methods: {
    async initList(departId) {
      try {
        let { data } = await userSearch(departId);
        if (data.returnCode === '01') {
          this.pageData = data.userList;
          this.tableData = data.userList;
          this.pageParams.totalCount = data.size;
          this.pageParams.totalPage = this.totalPageCount;
        } else {
          this.$message.error('查询用户数据失败！');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    },
    userStatus: function(status) {
      return this.$options.filters['userStatus'](status);
    },
    returnUserStatus: function(statusName) {
      let userStatus = USER_ROLE_GROUP.userStatus;
      let status = [];
      userStatus.forEach(item => {
        if (item.text.indexOf(statusName) !== -1) {
          status.push(item.id);
        }
      });
      return status;
    },
    change(value) {
      let searchData = clone(this.tableData);
      if (value === '') {
        this.pageData = searchData;
        this.pageParams.totalCount = searchData.length;
        this.pageParams.totalPage = this.totalPageCount;
        return false;
      }
      let data = [];
      searchData.forEach(item => {
        if (
          item.trueName.indexOf(value) !== -1 ||
          item.departName.indexOf(value) !== -1 ||
          item.userPhone.indexOf(value) !== -1 ||
          item.userEmail.indexOf(value) !== -1 ||
          item.userRoleNames.indexOf(value) !== -1 ||
          this.returnUserStatus(value).indexOf(item.status) !== -1
        ) {
          data.push(item);
        }
      });
      this.pageParams.totalCount = data.length;
      this.pageParams.totalPage = this.totalPageCount;
      this.pageData = data;
    },
    handleCurrentChange(val) {
      this.pageParams.currPage = val;
    },
    // 当前选中行改变操作
    handleCurrentRowChange(currRow) {
      this.radioValue = this.pageData.indexOf(currRow);
      this.currentSelectedRow = currRow;
    },
    addUser: function() {
      eventBus.$emit('addUser', this.currentDept);
    },
    deleteUser: function() {
      if (!this.currentSelectedRow) {
        this.$message.error('请选择一个用户进行删除！');
        return false;
      }
      let userId = this.currentSelectedRow.userId;
      if (userId === this.managerUserId) {
        this.$message.error('您的身份为管理员，不能删除自己。');
        return false;
      }
      this.$ebConfirm('确定要删除此用户吗?')
        .then(() => {
          this.deleteSelectUser(userId);
        })
        .catch(() => {});
    },
    async deleteSelectUser(userId) {
      try {
        let params = {
          userId: userId
        };
        let { data } = await deleteU(params);
        if (data.returnCode === '01') {
          this.$message.success('删除用户成功');
          eventBus.$emit('addOrEditDeptsuccess');
        } else {
          this.$message.error('删除用户失败');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接！');
      }
    },
    editUser: function() {
      if (!this.currentSelectedRow) {
        this.$message.error('请选择一个用户进行修改！');
        return false;
      }
      this.$router.push('/user/edit/' + this.currentSelectedRow.userId);
    },
    setUserStatus: function() {
      if (!this.currentSelectedRow) {
        this.$message.error('请选择一条用户信息进行设置状态！');
        return false;
      }
      eventBus.$emit('setUserStatus', this.currentSelectedRow.userId, this.currentSelectedRow.status);
    },
    resetUserPassword: function() {
      if (!this.currentSelectedRow) {
        this.$message.error('请选择一条用户信息进行密码重置！');
        return false;
      }
      let userId = this.currentSelectedRow.userId;
      this.$ebConfirm('确定要重置密码吗?')
        .then(() => {
          this.resetUserPwd(userId);
        })
        .catch(() => {});
    },
    async resetUserPwd(userId) {
      try {
        let params = {
          userIDs: userId
        };
        let { data } = await initPwd(params);
        if (data.returnCode === '01') {
          this.$message.success('重置密码成功');
        } else {
          this.$message.error('重置密码失败');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接！');
      }
    },
    setNewManageUser: function() {
      if (!this.currentSelectedRow) {
        this.$message.error('请选择一条用户信息进行设置管理员！');
        return false;
      }
      if (this.$store.state.user.userInfo.isMultiRoles !== '1') {
        this.$message.error('本机构不允许转移管理员，请于平台管理方联系！');
        return false;
      }
      if (this.currentSelectedRow.status === '2') {
        this.$message.error('禁止登录状态的用户不能设定为管理员');
        return false;
      }
      let userId = this.currentSelectedRow.userId;
      if (userId === this.managerUserId) {
        this.$message.error('您已经是管理员，无需重新设置。');
        return false;
      }
      this.$ebConfirm(
        '每个机构只能有一个用户具备管理权限。将管理权限转移给他人，您将失去管理权限，且自动退出本系统，需重新登录。是否继续？'
      )
        .then(() => {
          this.confirmSetNewManagerUser(userId);
        })
        .catch(() => {});
    },
    async confirmSetNewManagerUser(userId) {
      try {
        let params = {
          roleId: this.$store.state.user.userInfo.roleid,
          oldManageUserId: this.managerUserId,
          newManageUserId: userId
        };
        let { data } = await setNewManageUser(params);
        if (data.returnCode === '01') {
          this.$message.success('重新设置管理员成功');
          this.$store.dispatch('logout');
        } else if (data.returnCode === '03') {
          this.$message.error('参数不完整');
        } else {
          this.$message.error('重新设置管理员失败');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接！');
      }
    }
  },
  beforeDestroy() {
    eventBus.$off('selectDeptNode');
    eventBus.$off('addUserSuccess');
  }
};
</script>
<style lang="less" scoped>
#DeptUser {
  .search {
    width: 100%;
    height: 40px;
    .searchItem {
      width: 30%;
      float: right;
      input {
        width: 260px;
      }
    }
  }
  .deptUserButton {
    width: 100%;
    height: 22px;
    margin-top: 13px;
    text-align: right;
    button {
      width: 88px;
    }
  }
  .deptUserTable {
    width: 100%;
    margin-top: 15px;
  }
}
</style>
